<template>
  <div class="default-modal" :style="{ width, maxHeight }">
    <div class="default-modal__header">
      <slot name="header" />
    </div>

    <div class="default-modal__content">
      <slot name="content" />
    </div>

    <div class="default-modal__footer">
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
export default {
  name: "DefaultModal",
  props: {
    width: {
      type: String,
      default: '900px'
    },
    maxHeight: {
      type: String,
      default: '80%'
    }
  }
}
</script>

<style lang="scss" scoped>
  .default-modal {
    position: fixed;
    top: 10%;
    left: calc(50% - 450px);
    z-index: 999;
    background: white;
    border-radius: 1rem;
    overflow: hidden;
    overflow-y: scroll;
    box-shadow: 0 0 0 100vw rgba(0, 0, 0, 0.5);

    &__content {
      padding: 3rem 6.25rem;
    }

    &__footer {
      margin-bottom: 2rem;
      padding: 0 6.25rem;
    }

    &::-webkit-scrollbar {
      width: 0.5rem;
    }

    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px lightgray;
      border-radius: 0.5rem;
    }

    &::-webkit-scrollbar-thumb {
      background: lightgray;
      border-radius: 0.5rem;
    }

  }

  @media(max-width: 900px) {
    .default-modal {
      width: 95% !important;
      left: 2.5%;

      &__content {
        padding: 3rem 1rem;
      }

      &__footer {
        padding: 0 1rem;
        margin-bottom: 3rem;
      }
    }
  } 
</style>